module.exports = __webpack_public_path__ + "static/media/inspectionIcon2.7d2fb8d8.svg";